import { call, put, select } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrBackupMetadataService } from '../services/pcrBackupMetadata.service'
import { IPcrBackupMetadata } from '../store/pcrBackup.types'
import { setBackupMetadata } from '../store/pcrBackup.actions'

export function* loadBackupMetadataForChart(pcrId: string) {
  const serviceId: string = yield select(getServiceIdSelector)
  const metadataService = new PcrBackupMetadataService(serviceId)
  const metadata: IPcrBackupMetadata | null = yield call([metadataService, metadataService.getMetadata], pcrId)
  yield put(
    setBackupMetadata(metadata ?? { pcrId, lastSuccessfulBackupTime: null, lastSuccessfulBackupChecksum: null })
  )
}
